import { useTranslation } from '@sm360/hooks'
import { updateDrCalculatorStart } from '@sm360/helpers'
import { Card, CardSection, Icon, InputCurrency, Modal, Select } from '@sm360/ui-library'
import React from 'react'

import { getQuoteDeskingPaymentOptions, getQuoteDeskingPaymentRoll } from '../../../apis/showroom/showroom.service'
import { Context } from '../../../configs/state.manager'
import { payloadPaymentOptionsTransform } from '../../../transforms/payloadPaymentOptions.transform'
import { payloadPaymentRollTransform } from '../../../transforms/payloadPaymentRoll.transform'

const LeaseCard = () => {
    const {
        state,
        state: {
            dealerInfos: { lang },
            paymentOptions: {
                finance,
                paymentFrequency,
                kmPerYearPlan,
                cashDown,
                tradeIn,
                lien,
                disclaimer,
                __paymentOptionsMeta,
            },
            quoteId,
            vehicle,
        },
        dispatch,
    } = React.useContext(Context)

    const { t } = useTranslation()

    const { payment, apr } = finance?.term || {}

    const metaData = __paymentOptionsMeta.find(({ purchaseMethod }) => purchaseMethod === 'lease')
    const frequencyOptions = metaData.paymentFrequencies.map((item) => {
        return {
            id: item,
            value: item,
            label: t(`pc.paymentFrequency.${item}`),
        }
    })
    const kmPlanOptions = metaData.kmPerYearPlans.map((item) => {
        return {
            id: item,
            value: item,
            label: item,
        }
    })

    const handleChange = async (value) => {
        try {
            const payload = payloadPaymentOptionsTransform({ state, ...value })
            const initPaymentOptions = await getQuoteDeskingPaymentOptions(payload)

            updateDrCalculatorStart(quoteId, vehicle, 'lease')

            dispatch({ type: 'setPaymentOptions', paymentOptions: initPaymentOptions.data })
        } catch (error) {
            console.error(error)
        }
    }

    const handleTargetPaymentChange = async (value) => {
        try {
            const payloadPaymentRoll = payloadPaymentRollTransform({ state, ...value })
            const targetPaymentRoll = await getQuoteDeskingPaymentRoll(payloadPaymentRoll)

            const cashdownUpdate = targetPaymentRoll.data?.negociationTransaction?.cashDown

            const payloadPaymentOptions = payloadPaymentOptionsTransform({ state, cashDown: cashdownUpdate })
            const initPaymentOptions = await getQuoteDeskingPaymentOptions(payloadPaymentOptions)

            updateDrCalculatorStart(quoteId, vehicle, 'lease')

            dispatch({ type: 'setPaymentOptions', paymentOptions: initPaymentOptions.data })
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <div className='pc-leaseCard'>
            <Card className='pc-leaseCard__wrapper'>
                <CardSection className='pc-leaseCard__section'>
                    <div className='pc-leaseCard__title'>{t('pc.lease')}</div>

                    <div className='pc-leaseCard__resume'>
                        <div className='pc-leaseCard__targetPaymentResume'>
                            <InputCurrency
                                id='targetPayment'
                                name='targetPayment'
                                className='pc-leaseCard__targetPaymentSelected'
                                value={payment}
                                displayAsText
                                displayWithTwoDecimals
                                locale={lang}
                            />

                            <Modal
                                modalTitle=''
                                trigger={
                                    <span>
                                        <Icon name='info-circle' className='pc-leaseCard__icon' />
                                    </span>
                                }
                                className='pc-modal__inner'
                            >
                                <div className='pc-disclaimer'>{disclaimer}</div>
                            </Modal>

                            <div className='pc-leaseCard__frequencySelected'>
                                {t(`pc.byPaymentFrequency.${paymentFrequency}`)}
                            </div>
                        </div>
                        <div className='pc-leaseCard__rateResume'>
                            <div className='pc-leaseCard__rateLabel'>{t('pc.rate')}:</div>
                            <div className='pc-leaseCard__rateValue'>{apr}%</div>
                        </div>
                    </div>

                    <InputCurrency
                        id='payment'
                        name='payment'
                        label={t('pc.targetPaymentAmount')}
                        className='pc-leaseCard__input pc-leaseCard__targetPayment'
                        value={payment}
                        onChange={(v) => handleTargetPaymentChange({ payment: v })}
                        locale={lang}
                    />

                    <Select
                        id='paymentFrequency'
                        name='paymentFrequency'
                        label={t('pc.paymentFrequency')}
                        className='pc-leaseCard__input pc-leaseCard__frequency'
                        options={frequencyOptions}
                        value={paymentFrequency}
                        onChange={(v) => handleChange({ paymentFrequency: v })}
                        locale={lang}
                    />

                    <InputCurrency
                        id='cashDown'
                        name='cashDown'
                        label={t('pc.cashdown')}
                        className='pc-leaseCard__input pc-leaseCard__cashDown'
                        value={cashDown}
                        onChange={(v) => handleChange({ cashDown: v })}
                        locale={lang}
                    />

                    <InputCurrency
                        id='tradeIn'
                        name='tradeIn'
                        label={t('pc.tradeInEstimate')}
                        className='pc-leaseCard__input pc-leaseCard__tradeIn'
                        value={tradeIn}
                        onChange={(v) => handleChange({ tradeIn: v })}
                        locale={lang}
                    />

                    <InputCurrency
                        id='lien'
                        name='lien'
                        label={t('pc.lien')}
                        className='pc-leaseCard__input pc-leaseCard__lien'
                        value={lien}
                        onChange={(v) => handleChange({ lien: v })}
                        locale={lang}
                    />

                    <Select
                        id='kmPerYearPlan'
                        name='kmPerYearPlan'
                        label={t('pc.kmPerYearPlan')}
                        className='pc-leaseCard__input pc-leaseCard__kmPlan'
                        options={kmPlanOptions}
                        value={kmPerYearPlan}
                        onChange={(v) => handleChange({ kmPerYearPlan: v })}
                    />
                </CardSection>
            </Card>
        </div>
    )
}

export default LeaseCard
